import { render, staticRenderFns } from "./Zczxdwzxcx.vue?vue&type=template&id=f0097064"
import script from "./Zczxdwzxcx.vue?vue&type=script&lang=js"
export * from "./Zczxdwzxcx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports